import { mapValues } from 'lodash/fp'

import { mapOperationResult } from './helpers/mapOperationResult'

// * CONTEXT
// this is responsible for transforming serialized ISO date STRINGS
// that come as parts of the GQL responses from BE
// into proper JavaScript DATE objects
// ! to keep this working the object defined bellow needs to be updated:
// !  - when new date is being fetched (or an old one under new key), ADD THAT KEY
// !      to the corresponding GQL type (or add that type if it does not exist yet)
// !  - if some GQL property in existing fragment/operation pointing to a Date is renamed
// !      RENAME that property here as well (or add it as new if it’s still fetched under the old name
// !      in another operation as well)

// object where keys are TYPE NAMES of some GQL type from our BE schema
// and values are ARRAYS! of PROPERTY NAMES of that specific type
// these values has to reflect our FE renames so it needs to be updated each time we rename
// or add a new date field that should be transformed
const GQL_DATE_FIELDS = {
  DeliverySlot: [`startsAt`, `endsAt`],
  CompanyBranch: [`willOpenAt`, `willCloseAt`],
  BusinessHourInterval: [`startsAt`, `endsAt`, `belongsIntoDay`],
  Order: [`updateTimestamp`, `expectedHandoverTime`, `handedOverAt`, `acceptedAt`],
  DateTimeWrapped: [`dateTime`],
  CreditsWalletActivity: [`createdAt`, `expiresAt`],
  CreditsReward: [`createdAt`, `expiresAt`],
}

// ignore this...
// creating object from those arrays above where keys are the values in that array
// and values are all nulls (not used anyway)
// the reason for this transformation is that the object will be better in usage (faster to search in)
// but the array seems to be cleaner way to describe it (DX)
const GQL_DATE_FIELDS_MAP = mapValues((propertyArray) => {
  return propertyArray.reduce(
    (acc, propertyName) => {
      acc[propertyName] = null

      return acc
    },
    {} as Record<string, null>,
  )
}, GQL_DATE_FIELDS)

const initDate = (isoDate: Nullable<DateString>) => (isoDate !== null ? new Date(isoDate) : null)

/**
 * transform function that will iterate over a GQL operation result object
 * and all of it nested properties
 * and based on `__typename` properties (those has to be present!)
 * replace date ISO STRINGS with Date JS OBJECTS
 *
 * ! make sure to call this only with unprocessed GQL responses (to have the right `__typename`s)
 */
export const initializeOperationDates = mapOperationResult(initDate)(GQL_DATE_FIELDS_MAP)
